import { findIndex, matches } from 'lodash'
import moment from 'moment-timezone'

const CLASS_YEARS = ['Senior', 'Junior', 'Sophomore', 'Freshman']
// Rank of each month within the school year, which starts Aug 1. Aug is rank 0 (first),
// Jul is rank 11 (last). Used to compare months across the Dec/Jan boundary correctly.
const SCHOOL_YEAR_MONTH_RANK = {
  Aug: 0,
  Sep: 1,
  Oct: 2,
  Nov: 3,
  Dec: 4,
  Jan: 5,
  Feb: 6,
  Mar: 7,
  Apr: 8,
  May: 9,
  Jun: 10,
  Jul: 11,
}

const isAfter = function (graduationYear, currentSeniorYear, schoolMonth, schoolClass) {
  const classYearOffset = findIndex(CLASS_YEARS, matches(schoolClass))
  const schoolYear = currentSeniorYear + classYearOffset
  const adjustedSchoolMonthIdx = SCHOOL_YEAR_MONTH_RANK[schoolMonth]
  const adjustedCurrentMonthIdx = SCHOOL_YEAR_MONTH_RANK[moment().format('MMM')]

  if (graduationYear > schoolYear) {
    return false
  }

  return graduationYear < schoolYear || adjustedCurrentMonthIdx >= adjustedSchoolMonthIdx
}

export default {
  isAfter,
}
